module.exports = __webpack_public_path__ + "media/leaderboard/assets/sebastien_ogier-27b41bfe98e8b78d1c176144469e6c32.png";